


























import { NotificationLevel } from '@/components/molecules/notification-section/model/notification-section-model'
import NotificationSectionWrapper from '@/components/molecules/notification-section/NotificationSectionWrapper.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    NotificationSectionWrapper,
  },
})
export default class WithIconNotificationSection extends Vue {
  @Prop({ required: true })
  readonly level: NotificationLevel
}
